import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CheckIcon } from '@heroicons/react/20/solid';
import React, { useState, ChangeEvent } from 'react';
import store from '../../../store';

type Props = {
  onClick: (promoId: string) => void;
};

const PromotionField: React.FC<Props> = ({ onClick }) => {
  const [promoId, setPromoId] = useState<string | null>(
    store.getState().cart.promotion != null
      ? store.getState().cart.promotion.promo_id
      : '',
  );
  return (
    <>
      <label className="mx-4 block uppercase tracking-wide text-on-surface text-sm font-bold mb-2 mt-4">
        Promo Code
      </label>
      <div className="py-2 pr-4 pl-4  sm:h-1/5 max-h-1/5 sm:flex rounded bg-surface">
        <div className="p-4 flex felx-row w-full rounded-lg  justify-between bg-primary/10">
          <input
            id="promo"
            type={'text'}
            value={promoId}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setPromoId(e.target.value)
            }
            disabled={store.getState().cart.promotion != null}
            className="appearance-none bg-surface-variant block w-full px-3 py-2 border border-outline-variant rounded-md placeholder-on-surface-variant/60 focus:ring-primary/70 focus:border-primary text-on-surface-variant transition duration-150 ease-in-out text-md sm:leading-5"
          />
          <button
            type="button"
            className={`${
              promoId == '' ? 'bg-surface-variant' : 'bg-primary'
            } text-center align-center text-sm font-bold ml-2 rounded-md px-8 md:px-16 py-2 outline-none focus:outline-none justify-center`}
            onClick={() => {
              onClick(promoId);
            }}
          >
            {<CheckIcon className="text-on-primary w-4 h-4 " />}
          </button>
        </div>
      </div>
    </>
  );
};

export default PromotionField;
